import { Controller } from '@hotwired/stimulus';
import { Modal } from 'bootstrap';

// スタンダードプラン限定機能のページに無料プランで直アクセスした際、
// 案内モーダルを自動で開く (#1640)。
export default class extends Controller {
  connect() {
    Modal.getOrCreateInstance(this.element).show();
  }
}
